import React from "react";
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import classes from "./styles.module.css"; 
import { useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import ReactLoading from "react-loading"; 
import {
    Box,
    Center,
    Heading,
    Text,
    Button,
    VStack,
    StackDivider,
    HStack,
} from '@chakra-ui/react';

function MediaSosialPeserta() {
    const [instagram, setInstagram] = useState('');
    const [github, setGithub] = useState('');
    const [linkedin, setLinkedin] = useState('');
    const [spinner, setSpinner] = useState(false);  

    const getPesertaById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data;
        setInstagram(data.instagram);
        setGithub(data.github);
        setLinkedin(data.linkedin);
        console.log("ada")
        setSpinner(false);
    };

    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <div className="container">
            <div>
                <Center py={6}>
                    <VStack align='stretch' fontFamily={'Inter'}>
                        <Text
                            pt={10}
                            paddingBottom={10}
                            color={'gray.700'}
                            fontWeight={600}
                            fontSize={'3xl'}>
                            Profil
                        </Text>
                        <HStack color={'gray.500'} pb={3}>
                            <Link to="/peserta/profile"> Profil </Link>
                            <p> / </p>
                            <Link to="/peserta/profile/mediasosial"> Media Sosial </Link>
                        </HStack>
                            <Box
                                m='10px'
                                w='4xl'
                                h="100%"
                                border='1px'
                                borderColor='gray.200'
                                justifyContent='left'
                                rounded={'2xl'}
                                p={6}
                                className={classes.box}
                                overflow={'hidden'}>
                                <VStack 
                                divider={<StackDivider borderColor='gray.200' />}
                                spacing={4}
                                align='stretch'
                                >
                                    <Heading
                                        fontSize={'xl'}
                                        fontFamily={'Inter'}>
                                        Media Sosial
                                    </Heading>
                                    <div justifyContent='left' justifyItems='left'>
                                        <h3 className={classes.h} >Instagram</h3>
                                        <p className={classes.p}>{instagram}</p>
                                    </div>

                                    <div>
                                        <h3 className={classes.h}>Linkedin</h3>
                                        <p className={classes.p}>{linkedin}</p>
                                    </div>

                                    <div>
                                        <h3 className={classes.h}>Github</h3>
                                        <p className={classes.p}>{github}</p>
                                    </div>

                                </VStack>
                                <Center pt={6}>
                                    <Link to={`/peserta/profile/isi-mediasosial/${id}`} >
                                        <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                                            Edit Media Sosial
                                        </Button>
                                    </Link>
                                </Center>
                            </Box>
                    </VStack>
                </Center>
            </div>
        </div>
    );
}

export default MediaSosialPeserta;